var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTheaccubin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "416.000000pt",
    height: "182.000000pt",
    viewBox: "0 0 416.000000 182.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,182.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 930 l0 -890 885 0 885 0 1 193 c1 105 1 505 0 887 l-2 695 -884 3 -885 2 0 -890z m1214 292 c39 -30 74 -60 79 -67 4 -8 6 -134 5 -282 l-3 -268 -412 -3 -413 -2 0 338 c0 186 3 342 7 345 3 4 155 4 337 0 l330 -6 70 -55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1970 1693 c0 -71 4 -134 9 -142 5 -7 32 -16 60 -19 l51 -5 0 -208 c0 -115 3 -209 6 -209 22 0 203 167 416 385 l98 99 0 113 0 113 -320 0 -320 0 0 -127z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2770 1675 l0 -145 55 0 55 0 0 -210 c0 -203 1 -210 19 -201 10 6 116 107 234 225 119 118 226 217 237 221 31 10 40 45 40 156 l0 99 -320 0 -320 0 0 -145z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3550 1691 c0 -71 3 -136 6 -145 5 -12 21 -16 70 -16 l63 0 7 -36 c4 -20 3 -115 -1 -211 -6 -146 -5 -174 7 -168 30 18 150 119 158 134 4 9 30 36 56 61 26 25 79 77 118 116 39 39 83 79 99 89 l27 17 0 144 0 144 -305 0 -305 0 0 -129z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2377 1148 c-174 -171 -240 -242 -248 -268 -15 -45 -12 -840 2 -855 6 -6 105 -10 257 -10 l246 0 13 25 c10 19 13 171 13 683 l0 657 -23 0 c-17 0 -89 -65 -260 -232z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3167 1177 c-117 -113 -230 -225 -250 -250 l-37 -45 0 -436 0 -436 259 2 260 3 3 679 c2 521 0 680 -9 683 -7 3 -108 -88 -226 -200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4128 1322 c-15 -10 -62 -54 -105 -98 -43 -44 -121 -119 -174 -167 -53 -47 -109 -105 -125 -128 l-29 -42 0 -436 0 -436 233 -3 232 -2 0 665 c0 366 -1 665 -2 665 -2 0 -15 -8 -30 -18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheaccubin);
export default __webpack_public_path__ + "static/media/theaccubin.e0cbe258b38a1efd7170643df3302f4a.svg";
export { ForwardRef as ReactComponent };